import React, { useEffect, useState } from "react"; // Add useState
import {
  Container,
  TextField,
  Switch,
  FormControlLabel,
  Button,
  Typography,
  Divider,
  Box,
  FormControl,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  InputLabel,
  Select,
  MenuItem,
} from "@mui/material";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { useDispatch, useSelector } from "react-redux";
import { fetchUsers, setSelectedUser, updateUser,clearMessage ,clearSelectedUser} from "../store/userSlice";
import {
  fetchUserPermissions,
  setSelectedPermission,
  updateUserPermission,
} from "../store/userPermissionsSlice";
import MySelect from "../components/MySelect";
import { showSnackbar } from "../store/snackbarSlice";
import { getPermissionsByRole } from "../services/utils";

const UserManagement = () => {
  const { users, selectedUser,message, error } = useSelector((state) => state.user);
  const { selectedPermission } = useSelector((state) => state.permission);
  const dispatch = useDispatch();
  const [permissionObject , setPermissionObject] = useState();
  // Local state for user form
  const [localUser, setLocalUser] = useState(null);

  // Fetch users on component mount
  useEffect(() => {
    dispatch(fetchUsers());

    return () => {
          dispatch(clearSelectedUser());
          
        };

  }, [dispatch]);

  // Sync local user state with selectedUser and fetch permissions
  useEffect(() => {
    if (selectedUser) {
      setLocalUser({ ...selectedUser }); // Initialize local user state
      dispatch(fetchUserPermissions(selectedUser._id)); // Fetch permissions
    } else {
      setLocalUser(null); // Clear local user state
      dispatch(setSelectedUser(null)); // Clear user
    }
  }, [selectedUser, dispatch]);

  // Show snackbar for messages or errors
  useEffect(() => {
    if (message || error) {
      const type = message ? "success" : "error";
      const content = message || error;
      dispatch(showSnackbar({ message: content, severity: type }));
      dispatch(clearMessage());
    }
  }, [message, error, dispatch]);

  // Handle user selection
  const handleUserChange = (e) => {
    const userId = e.target.value;
    const user = users.find((s) => s._id === userId);
    dispatch(setSelectedUser(user || null)); // Update selectedUser in Redux
  };

  useEffect(() => {
    console.log(permissionObject)
    } , [permissionObject]);
  // Handle local user changes (e.g., email, active status)
  const handleLocalUserChange = (e) => {
    const { name, value, checked, type } = e.target;
    const newValue = type === "checkbox" ? checked : value;
    
    
    if(name==="role"){ 

        setPermissionObject(
          getPermissionsByRole(value)
        )

  }
  
    setLocalUser((prevUser) => ({
      ...prevUser,
      [name]: newValue,
    }));

  };

  // Save user data
const handleSubmitUser = () => {
 

  const updates = {};

    updates.role = localUser.role;
    updates.email = localUser.email;
    updates.isActif = localUser.isActif;


  if (Object.keys(updates).length > 0) {
    dispatch(updateUser({ ...updates, userId: selectedUser._id }));
  }
};


  // Handle permission change
  const handlePermissionChange = (e) => {
    const { name, value, checked, type } = e.target;
    const newValue = type === "checkbox" ? checked : value;

    if (name.includes(".")) {
      const [category, permissionKey] = name.split(".");
      dispatch(
        setSelectedPermission({
          ...selectedPermission,
          [category]: {
            ...selectedPermission[category],
            [permissionKey]: newValue,
          },
        })
      );
    } else {
      dispatch(setSelectedPermission({ ...selectedPermission, [name]: newValue }));
    }
  };

  // Save permissions
  const handleSubmitPermissions = () => {
    if (!selectedUser || !selectedPermission) return;
    const permissionsData = {
      userId: selectedUser._id,
      ...selectedPermission,
    };
    dispatch(updateUserPermission(permissionsData));
  };

  // Render permissions section
  const renderPermissionsSection = (selectedPermission) => {
    if (!selectedPermission) return null;

    const validCategories = ['delete', 'update', 'create', 'display', 'routing'];

    return Object.entries(selectedPermission)
      .filter(([category]) => validCategories.includes(category))
      .map(([category, permissionsGroup]) => (
        <Accordion key={category}>
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <Typography variant="h6">
              {category.charAt(0).toUpperCase() + category.slice(1)}
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            {Object.entries(permissionsGroup || {}).map(([permissionKey, value]) => {
              const isBoolean = typeof value === 'boolean';

              return (
                <Box key={permissionKey} sx={{ mb: 1 }}>
                  {isBoolean ? (
                    <FormControlLabel
                      control={
                        <Switch
                          checked={value}
                          onChange={handlePermissionChange}
                          name={`${category}.${permissionKey}`}
                        />
                      }
                      label={permissionKey.replace(/([A-Z])/g, ' $1').toUpperCase()}
                    />
                  ) : (
                    <TextField
                      label={permissionKey.replace(/([A-Z])/g, ' $1').toUpperCase()}
                      value={value || ''}
                      onChange={handlePermissionChange}
                      name={`${category}.${permissionKey}`}
                      fullWidth
                    />
                  )}
                </Box>
              );
            })}
          </AccordionDetails>
        </Accordion>
      ));
  };

  return (
    <Container maxWidth="sm">
      <Typography variant="h5" gutterBottom>
        User Management
      </Typography>

      <FormControl fullWidth margin="normal">
        <MySelect
          label="Select Users"
          options={users}
          value={selectedUser?._id || ""}
          onChange={handleUserChange}
          multiple={false}
          getOptionValue={(option) => option._id}
          getOptionLabel={(option) => option.login}
        />
      </FormControl>

      {localUser && (
        <>
          <TextField
            fullWidth
            label="Email"
            name="email"
            type="email"
            value={localUser.email || ""}
            onChange={handleLocalUserChange}
            margin="normal"
          />
          <FormControl fullWidth margin="normal">
            <InputLabel>Role</InputLabel>
            <Select
              name="role"
              value={localUser.role || ""}
              onChange={handleLocalUserChange}
            >
              <MenuItem value="manager">Manager</MenuItem>
              <MenuItem value="magasinier">Magasinier</MenuItem>
              <MenuItem value="commercial">Commercial</MenuItem>
            </Select>
          </FormControl>
          <FormControlLabel
            control={
              <Switch
                checked={Boolean(localUser.isActif)}
                onChange={handleLocalUserChange}
                name="isActif"
              />
            }
            label="Active"
          />

          <Button
            variant="contained"
            color="primary"
            onClick={handleSubmitUser}
            fullWidth
          >
            Save User
          </Button>
        </>
      )}

      <Divider sx={{ my: 3 }} />

      <Typography variant="h5" gutterBottom>
        Permissions
      </Typography>

      <Box
        component="form"
        onSubmit={(e) => {
          e.preventDefault();
          handleSubmitPermissions();
        }}
      >
        {renderPermissionsSection(permissionObject)}

        {/* <TextField
          fullWidth
          label="Default Routing"
          name="defaultRouting"
          value={selectedPermission?.defaultRouting || ""}
          onChange={handlePermissionChange}
          margin="normal"
        />

        <Button
          variant="contained"
          color="secondary"
          type="submit"
          fullWidth
          disabled={!selectedUser || !selectedPermission}
        >
          Save Permissions
        </Button> */}
      </Box>
    </Container>
  );
};

export default UserManagement;